import Vue from 'vue';
import { randomUUID } from '@/utils/util';
import { getAction } from "@/api/manage";
import { mixinDevice } from '@/utils/mixin.js';
export default {
  name: "EventPay",
  mixins: [mixinDevice],
  data: function data() {
    return {
      visible: false,
      pcAlipayUrl: "https://pay.cacpaper.com/alipay/pay.jsp",
      mobileAlipayUrl: "https://pay.cacpaper.com/alipay/wap-pay.jsp",
      pcWxpayUrl: "https://pay.cacpaper.com/wxpay/pay",
      pcUnionpayUrl: "https://pay.cacpaper.com/unionpay/pay",
      mobileWxpayUrl: "https://pay.cacpaper.com/wxpay/h5-pay",
      mobileWxpayInWxUrl: "https://pay.cacpaper.com/wxpay/mp-pay",
      mobileWxpayInMiniAppUrl: "https://pay.cacpaper.com/minipay/mini-pay",
      body: '报名费',
      applyInfo: {},
      payInfo: {},
      callbackUrl: ""
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    open: function open(orderInfo, applyInfo) {
      console.log(orderInfo);
      console.log(applyInfo);
      this.payInfo = {
        orderNo: orderInfo.orderNo,
        orderPrice: orderInfo.orderPrice / 100
      };
      //this.callbackUrl = window.location.protocol + "//" + window.location.host + "/cert/payResult.html?orderId=" + this.payInfo.orderNo
      this.callbackUrl = window.location.href + '#payok';
      this.applyInfo = applyInfo;
      this.visible = true;
    },
    checkOrder: function checkOrder(orderId) {
      var _this = this;
      getAction("/teaching/teachingOrder/checkOrderCAC?outTradeNo=" + orderId).then(function (res) {
        if (res.success) {
          _this.$message.success('支付成功');
          _this.$emit("payOk");
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    pay: function pay(type) {
      var that = this;
      var realname = "";
      if (this.applyInfo && this.applyInfo.realname) {
        realname = this.applyInfo.realname;
      } else {
        realname = this.$store.getters.userInfo.realname;
      }
      var body = "AICE测评-" + realname + this.payInfo.orderNo;
      switch (type) {
        case 1:
          this.pcWxpay(body, this.payInfo);
          break;
        case 2:
          this.mobileWxpay(body, this.payInfo);
          break;
        case 3:
          this.mobileWxpayInWx(body, this.payInfo);
          break;
        case 4:
          this.pcAlipay(body, this.payInfo);
          break;
        case 5:
          this.mobileAlipay(body, this.payInfo);
          break;
      }
      this.$confirm({
        title: '是否支付成功?',
        content: '请在打开的页面进行付款，付款后，确认付款结果',
        onOk: function onOk() {
          that.checkOrder(that.payInfo.orderNo);
        },
        okText: "支付成功",
        onCancel: function onCancel() {
          that.checkOrder(that.payInfo.orderNo);
          alert("请联系老师处理");
        },
        cancelText: "支付失败"
      });
    },
    pcWxpay: function pcWxpay(body, payInfo) {
      var action = this.pcWxpayUrl;
      var params = {
        WX_out_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WX_product_id: "101",
        WX_total_fee: payInfo.orderPrice,
        WX_body: body,
        WX_return_url: this.callbackUrl
      };
      var form = this.createForm(action, params, "_blank");
      form.submit();
    },
    mobileWxpay: function mobileWxpay(body, payInfo) {
      var action = this.mobileWxpayUrl;
      var params = {
        WX_out_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WX_total_fee: payInfo.orderPrice,
        WX_body: body,
        WX_return_url: this.callbackUrl
      };
      var form = this.createForm(action, params, "_blank");
      form.submit();
    },
    mobileWxpayInWx: function mobileWxpayInWx(body, payInfo) {
      var action = this.mobileWxpayInWxUrl;
      var params = {
        WX_out_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WX_total_fee: payInfo.orderPrice,
        WX_body: body,
        WX_return_url: this.callbackUrl
      };
      var form = this.createForm(action, params, "_self");
      form.submit();
    },
    mobileAlipay: function mobileAlipay(body, payInfo) {
      var action = this.mobileAlipayUrl;
      var params = {
        WIDout_trade_no: payInfo.orderNo,
        original_id: payInfo.orderNo,
        WIDsubject: body,
        WIDtotal_fee: payInfo.orderPrice,
        WIDbody: body,
        WIDreturn_url: this.callbackUrl
      };
      var form = this.createForm(action, params, "_self");
      form.submit();
    },
    pcAlipay: function pcAlipay(body, payInfo) {
      var action = this.pcAlipayUrl;
      var params = {
        WIDout_trade_no: payInfo.orderNo,
        WIDsubject: body,
        original_id: payInfo.orderNo,
        WIDtotal_fee: payInfo.orderPrice,
        WIDbody: body,
        WIDreturn_url: this.callbackUrl
      };
      var form = this.createForm(action, params, "_blank");
      form.submit();
    },
    pcUnionpay: function pcUnionpay(body, payInfo) {
      var action = this.pcUnionpayUrl;
      var params = {
        orderId: payInfo.orderNo,
        txnAmt: payInfo.orderPrice,
        original_id: payInfo.orderNo,
        WIDsubject: "报名-" + body,
        WIDbody: body,
        channel: "pc",
        frontUrl: this.callbackUrl
      };
      var form = this.createForm(action, params, "_blank");
      form.submit();
    },
    mobileUnionpay: function mobileUnionpay(body, payInfo) {
      var action = this.pcUnionpayUrl;
      var params = {
        orderId: payInfo.orderNo,
        txnAmt: payInfo.orderPrice,
        original_id: payInfo.orderNo,
        WIDsubject: "报名-" + body,
        WIDbody: body,
        channel: "mobile",
        frontUrl: this.callbackUrl
      };
      var form = this.createForm(action, params, "_blank");
      form.submit();
    },
    //创建post表单
    createForm: function createForm(action, params, target) {
      console.log("createForm");
      console.log(action);
      console.log(params);
      //alert(JSON.stringify(params))
      var temp = document.createElement("form"); //创建form标签
      temp.action = action; //这里写URL
      temp.method = "post"; //post方式提交
      temp.target = target;
      temp.style.display = "none"; //设置为不可见
      for (var key in params) {
        var element;
        element = document.createElement("input");
        element.setAttribute("type", "hidden");
        element.name = key;
        element.value = params[key];
        temp.appendChild(element);
      }
      document.body.appendChild(temp); //将form标签添加到body标签内
      return temp;
    }
  }
};